import { camelCase } from 'lodash';

export const parseCalloutData = (data) => ({
  key: data.key,
  component: data.component,
  message: data.children[0].value
});

export const parseTitleData = (data) => ({
  key: data.key,
  component: data.component,
  title: data.children[0].value
});

export const parseSubtitleData = (data) => ({
  key: data.key,
  component: data.component,
  subtitle: data.children[0].value
});

export const parseImageData = (data) => {
  const propsMap = {
    url: 'src',
    text: 'alt'
  };

  let props = {
    key: data.key,
    component: data.component
  };

  data.children.forEach((prop) => {
    props = { ...props, [propsMap[prop.type]]: prop.value };
  });

  return props;
};
export const parseQuestionAnswerData = ({ key, component, children }) => {
  const parsedData = children.reduce((acc, element) => {
    acc[element.type] = element.value;
    return acc;
  }, {});
  return { key, component: camelCase(component), ...parsedData };
};

export const parseBulletListData = (data) => {
  const parsedData = data.children.map((bulletListItem) => (
    {
      key: bulletListItem.key,
      text: bulletListItem.value
    }));

  return { key: data.key, component: camelCase(data.component), listItems: parsedData };
};

export const parseNumberedListData = (data) => {
  const parsedData = data.children.reduce((acc, curr) => {
    if (curr.type === 'title') {
      return [...acc, curr];
    }
    const newObj = acc.pop();
    return [...acc, { title: newObj.value, subText: curr.value }];
  }, []);
  return { key: data.key, component: camelCase(data.component), listItems: parsedData };
};

export const parseParagraphData = (data) => ({
  key: data.key,
  component: camelCase(data.component),
  text: data.children[0].value
});

export const parseDisclaimerData = (data) => {
  let props = {
    key: data.key,
    component: data.component
  };

  data.children.forEach((prop) => {
    props = { ...props, [prop.type]: prop.value };
  });

  return props;
};

export const parseMediumTextData = (data) => ({
  key: data.key,
  component: camelCase(data.component),
  text: data.children[0].value
});

export const parseExtraLargeTextData = (data) => ({
  key: data.key,
  component: camelCase(data.component),
  text: data.children[0].value
});
